import * as Sentry from '@sentry/react';
import Phaser from 'phaser';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === 'true',
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: 'dark',
      showBranding: false,
      autoInject: false,
      triggerLabel: 'Report a Bug',
      formTitle: 'Report a Bug',
      themeDark: {
        background: '#0e1e30',
        backgroundHover: '#122840',
        foreground: '#a8d1ff',
        border: '1px solid #5aa0ff',
        boxShadow: '0 4px 24px rgba(0,0,0,0.7)',
        accentBackground: '#5aa0ff',
        accentForeground: '#ffffff',
        successColor: '#a0ffb0',
        errorColor: '#ffb0a0',
      },
    }),
  ],
});
import { SplashScene } from '@/SplashScene.ts';
import { MapScene } from '@/MapScene';
import { CombatScene } from '@/CombatScene';
import { initReactUI } from '@/ui/main';
import { SpriteZipLoaderPlugin } from '@/loaders/SpriteZipLoader';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: window.innerWidth,
  height: window.innerHeight,
  parent: 'game-container',
  backgroundColor: '#2d2d2d',
  scene: [SplashScene, MapScene, CombatScene],
  input: {
    activePointers: 2,
  },
  plugins: {
    global: [
      {
        key: 'SpriteZipLoaderPlugin',
        plugin: SpriteZipLoaderPlugin,
        start: true,
      },
    ],
  },
  scale: {
    mode: Phaser.Scale.EXPAND,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
};

// Initialize the Phaser game and expose it globally for UI control
const game = new Phaser.Game(config);
window.phaserGame = game;

// Initialize React UI overlay
initReactUI();

console.log('🎮 Phaser game initialized');
console.log('⚛️ React UI overlay initialized');
console.log('📡 Connecting to backend at http://localhost:3000');
